import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const PasteDialog = ({ open, onClose, onSaved }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/sms/paste", { text });
      toast.success(`${data.added} saved · ${data.duplicates} already there`);
      setText("");
      onSaved();
      onClose();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="sms-paste-dialog">
        <DialogHeader>
          <DialogTitle className="font-['Outfit']">Paste & Save</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-[#6B6B61]">
          messages.google.com ki list pe Ctrl+A, Ctrl+C karke yahan paste karo. "mobile code" wali lines bhi chalengi.
        </p>
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={10} data-testid="sms-paste-input"
          placeholder={"098648 04665\n1a293c624c388668\n9 min"}
          className="w-full rounded-lg border border-[#E0DFD6] bg-[#FAFAF6] p-3 font-mono text-sm focus:outline-none focus:ring-2 focus:ring-[#385C4B]/30" />
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="h-9 px-4 rounded-full border border-[#E0DFD6] text-sm" data-testid="sms-paste-cancel">Cancel</button>
          <button onClick={save} disabled={busy || !text.trim()} data-testid="sms-paste-save"
            className="h-9 px-4 rounded-full bg-[#385C4B] text-white text-sm font-semibold inline-flex items-center gap-1.5 disabled:opacity-50">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Save
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
